import { Button } from '@shared/components/Button';
import { useUserContext } from '@shared/contexts/UserContextProvider';
import NotFoundPage from '../NotFoundPage';
import { Box } from '@mui/material';
import { useLiveMidPrices } from './hooks/useLiveMidPrices';
import { LiveMidPricesGrid } from './components/LiveMidPricesGrid';
import { checkIsInternalUser } from '@utils/permissions';

export const LiveMidPricesPage = () => {
  const user = useUserContext();
  const { isDataLoaded, refreshRowData, weeklyColumnDefs, weeklyRowData, getRowId, toolPanel, monthlyColumnDefs, monthlyRowData, defaultColDef } =
    useLiveMidPrices();

  if (!checkIsInternalUser(user)) {
    return <NotFoundPage />;
  }

  return (
    <Box style={{ height: '92vh', width: '100%' }}>
      <Box style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '10px' }}>
        <Button variant="contained" size="small" onClick={() => refreshRowData()}>
          Refresh Data
        </Button>

        {/* Legend */}
        <Box style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
          <Box style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <Box style={{ width: '20px', height: '20px', backgroundColor: '#94DF76', border: '1px solid #ccc' }}></Box>
            <span style={{ color: '#fffff2', fontSize: '14px' }}>Less than 15 min</span>
          </Box>
          <Box style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <Box style={{ width: '20px', height: '20px', backgroundColor: '#DFD476', border: '1px solid #ccc' }}></Box>
            <span style={{ color: '#fffff2', fontSize: '14px' }}>15-45 min</span>
          </Box>
          <Box style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <Box style={{ width: '20px', height: '20px', backgroundColor: '#E94E4E', border: '1px solid #ccc' }}></Box>
            <span style={{ color: '#fffff2', fontSize: '14px' }}>45+ min</span>
          </Box>
        </Box>
      </Box>

      {isDataLoaded && (
        <Box style={{ display: 'flex', flexDirection: 'column', height: 'calc(100% - 60px)' }}>
          <Box style={{ height: '50%', marginBottom: '10px' }}>
            <h3 style={{ margin: '0 0 10px 0', color: '#fffff2' }}>Monthly Tenors</h3>
            <LiveMidPricesGrid
              defaultColDef={defaultColDef}
              columnDefs={monthlyColumnDefs}
              rowData={monthlyRowData}
              getRowId={getRowId}
              toolPanel={toolPanel}
            />
          </Box>

          <Box style={{ height: '50%', width: '100%' }}>
            <h3 style={{ padding: '10px 0 0 0', color: '#fffff2' }}>Weekly Tenors</h3>
            <LiveMidPricesGrid
              defaultColDef={defaultColDef}
              columnDefs={weeklyColumnDefs}
              rowData={weeklyRowData}
              getRowId={getRowId}
              toolPanel={toolPanel}
            />
          </Box>
        </Box>
      )}
    </Box>
  );
};
